import { useEffect } from 'react';

/**
 * Met à jour le titre de l'onglet du navigateur.
 *
 * Dans une application monopage (SPA), le titre défini dans index.html reste
 * identique d'une page à l'autre : la navigation est gérée côté client et ne
 * recharge pas le document. Ce hook rétablit un titre propre à chaque écran,
 * ce qui améliore l'accessibilité (annonce du lecteur d'écran au changement de
 * page), le repérage dans l'historique et les onglets, et l'indexation.
 *
 * @param {string} titre  Titre de la page, sans le nom du site.
 */
export function useDocumentTitle(titre) {
  useEffect(() => {
    const SITE = 'Les Bazars de Keassa';
    document.title = titre ? `${titre} — ${SITE}` : SITE;
  }, [titre]);
}
